import { useEffect, useRef } from 'react'

import { useDrop } from 'react-dnd'

import { classNames } from '@/utils/helpers'

interface ScrollDropTargetProps {
  accept: string
  className?: string
}

export const ScrollBottomDropTarget = ({
  accept,
  className,
}: ScrollDropTargetProps) => {
  const scrollBottomDropRef = useRef(null)
  const [{ isOver }, drop] = useDrop({
    accept,
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  })

  drop(scrollBottomDropRef)

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (isOver) {
        scrollDown()
      } else {
        clearInterval(intervalId)
      }
    }, 10)

    return () => {
      if (intervalId !== null) {
        clearInterval(intervalId)
      }
    }
  }, [isOver])

  const scrollDown = (): void => {
    window.scrollBy(0, 10)
  }

  return (
    <div
      ref={scrollBottomDropRef}
      className={classNames(
        'fixed bottom-0 left-0 right-0 z-[47] h-[40px] w-full',
        className,
      )}
    />
  )
}
